import React from 'react';
import EmptyPage from '../EmptyPage';

const ProjectCreatePage: React.FC = () => {
  return (
    <EmptyPage
      title="프로젝트 생성"
      icon="Plus"
      description="새로운 번역 프로젝트를 생성합니다."
      parentTitle="프로젝트"
    />
  );
};

export default ProjectCreatePage;
